module.exports = __webpack_public_path__ + "static/img/bg-tr.4f15a78e.png";